import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import CheckOutStep from '../../Component/CheckOutStep';
import { createOrder } from '../../redux/actions/orderAction';
import { ORDER_CREATE_RESET } from '../../redux/constant/orderConstant';
import LoadingBox from '../../Component/LoadingBox';
import MessageBox from '../../Component/MessageBox';
import Button from '../../Component/Button/index';
import { getImageSrc } from '../../utils/imageUrl';


import './PlaceOrderScreen.less';

export default function PlaceOrderScreen() {
  const cart = useSelector(state => state.cart);
  const orderCreate = useSelector(state => state.orderCreate);
  const { loading, success, error, order } = orderCreate;
  const { cartItems = [], shipping = {}, payment } = cart;

  //console.log('createOrder en PlaceOrderScreen: ', orderCreate);

  const [itemsPrice, setItemsPrice] = useState('');
  const [shippingPrice, setShippingPrice] = useState('');
  const [taxPrice, setTaxPrice] = useState('');
  const [totalPrice, setTotalPrice] = useState('');

  //console.log('cart:  ' + JSON.stringify(cart));

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const toPrice = num => Number(num.toFixed(2)); //5.123 => "5.12" => 5.12

  //Se está utilizando reduce() para calcular el total del carrito de compras.
  //Aquí está lo que sucede:
  //cart.cartItems: Este es el arreglo de elementos del carrito de compras
  //sobre el cual se está aplicando reduce().
  //reduce(): Este método reduce el arreglo cart.cartItems a un solo valor.
  //a: Este es el acumulador, que se inicializa en 0. Representa el valor
  //acumulado en cada iteración del arreglo.
  //c: Este es el elemento actual del arreglo en la iteración actual.
  //a + c.qty * c.price: En cada iteración, se calcula el subtotal del
  //elemento actual multiplicando la cantidad (qty) por el precio (price)
  //del artículo y sumándolo al acumulador (a).
  //0: Este es el valor inicial del acumulador.
  //En resumen, el código está sumando el producto de la cantidad y el precio
  //de cada elemento del carrito de compras para calcular el total del carrito,
  // comenzando con un valor inicial de 0.

  // Validar que exista metodo de pago
  useEffect(() => {
    if (!cart.paymentMethod) {
      navigate('/payment');
    }

    const calculatePrices = () => {
      const newItemsPrice = toPrice(
        cart.cartItems.reduce((a, c) => a + c.qty * c.price, 0)
      );

      const newShippingPrice = newItemsPrice > 100 ? toPrice(0) : toPrice(10);
      const newTaxPrice = toPrice(0.15 * newItemsPrice);
      const newTotalPrice = toPrice(
        newItemsPrice + newShippingPrice + newTaxPrice
      );

      setItemsPrice(newItemsPrice);

      setShippingPrice(newShippingPrice);
      setTaxPrice(newTaxPrice);

      setTotalPrice(newTotalPrice);
    };

    calculatePrices();
  }, [navigate, cart.paymentMethod, cart.cartItems]);

  // Navegar después de crear orden exitosamente

  const placeOrderHandler = () => {
    //TODO dispatch place order action

    dispatch(
      createOrder({
        ...cart,
        orderItems: cartItems,
        shippingAddress: cart.shippingAddress,
        paymentMethod: cart.paymentMethod,
        itemsPrice,
        shippingPrice,
        taxPrice,
        totalPrice,
      })
    );
  };



  useEffect(() => {
    if (success) {

      navigate(`/order/${order._id}`);
      dispatch({ type: ORDER_CREATE_RESET });
    }
  }, [dispatch, order, navigate, success]);

  if (!cartItems || cartItems.length === 0) {
    return (
      <div>
        <CheckOutStep step1 step2 step3 step4>
          <MessageBox variant="info">
            Your cart is empty. <Link to="/">Go Shopping</Link>
          </MessageBox>
        </CheckOutStep>
      </div>
    );
  }

  return (
    <div>
      <CheckOutStep step1 step2 step3 step4></CheckOutStep>
      <div className="products top">
        <div className="col-2">
          <ul>
            {/* Shipping */}
            <li>
              <div className="order order-body">
                <h2>Shipping</h2>
                <p>
                  <strong>Name:</strong>
                  {cart.shippingAddress?.fullName || 'N/A'} <br />
                  <strong>Address:</strong>
                  {cart.shippingAddress?.address || ' '},
                  {cart.shippingAddress?.city || ''},
                  {cart.shippingAddress?.postalCode || ''},{' '}
                  {cart.shippingAddress?.country || ''}
                </p>
              </div>
            </li>
            {/* Payment */}
            <li>
              <div className="order order-body">
                <h2>Payment</h2>
                <p>
                  <strong>Method: </strong>
                  {cart.paymentMethod || 'Not Selected'}
                </p>
              </div>
            </li>
            {/* Order Items */}
            <li>
              <div className="order order-body">
                <h2>Order Items</h2>
                <ul>
                  {cart.cartItems.map(item => (
                    <li key={item.product}>
                      <div className="products">
                        <div>
                          <img
                            // src={item.imagen}
                            src={getImageSrc(item.imagen)}
                            alt={item.name}
                            className="small"
                          />
                        </div>
                        <div className="min-30">
                          <Link to={`/products/${item.product}`}>
                            {item.name}
                          </Link>
                        </div>
                        <div>
                          {item.qty} x ${item.price} = ${item.qty * item.price}
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div className="col-1">
          <div className="order order-body">
            <ul>
              <li>
                <h2>
                  <strong>Order Sumary</strong>
                </h2>
              </li>
              {/* Price */}
              <li>
                <div className="products">
                  <div>Items</div>
                  <div>${cart.itemsPrice}</div>
                </div>
              </li>
              {/* Tax */}
              <li>
                <div className="products">
                  <div>Tax</div>
                  <div>${cart.taxPrice}</div>
                </div>
              </li>
              {/* Total*/}
              <li>
                <Button
                  onClick={placeOrderHandler}
                  disabled={cart.cartItems.length === 0}
                >
                  {' '}
                  Place Order
                </Button>
              </li>
              {loading && <LoadingBox></LoadingBox>}
              {error && <MessageBox variant="danger">{error}</MessageBox>}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
